import { useEffect } from "react"

const APP_NAME = "dotlogic agents"

/** Set `document.title` to "<title> · dotlogic agents" while mounted. */
export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    if (!title) return
    const previous = document.title
    document.title = `${title} · ${APP_NAME}`
    return () => {
      document.title = previous
    }
  }, [title])
}
